import "./Button.scss";

export type ButtonProps = {
	className?: string;
	action?: any;
	children?: any;
	type?: "button" | "submit" | "reset" | undefined;
	name?: string;
	value?: string;
	disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
	action,
	className,
	children,
	type,
	name,
	value,
	disabled,
}) => {
	return (
		<button
			onClick={action}
			className={className}
			type={type ?? "submit"}
			value={value}
			name={name}
			disabled={disabled}
		>
			{children}
		</button>
	);
};

export default Button;
